import { Link, NavLink, Route, Routes } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useAuthContext } from '../../auth/AuthContext';
import AddApp from './AddApp';
import AppDetail from './AppDetail';
import HomebrewAccess from './HomebrewAccess';
import Library from './Library';
import './homebrew.scss';

export default function HomebrewRoutes() {
  const { isAuthenticated, signOut } = useAuthContext();
  const cache = useQueryClient();
  useEffect(
    () => () => {
      cache.removeQueries({ queryKey: ['homebrew'] });
    },
    [cache, isAuthenticated],
  );
  return (
    <div className="homebrew">
      <a className="govuk-skip-link" href="#homebrew-main">
        Skip to main content
      </a>
      <header className="govuk-header">
        <div className="govuk-header__container govuk-width-container">
          <Link className="govuk-header__link govuk-header__link--homepage" to="/homebrew">
            Homebrew
          </Link>
          <span className="homebrew-header-caption">MacBook software</span>
        </div>
      </header>
      <div className="govuk-service-navigation">
        <nav className="govuk-width-container homebrew-nav" aria-label="Homebrew">
          <NavLink className="govuk-link" to="/homebrew" end>
            My Apps
          </NavLink>
          <NavLink className="govuk-link" to="/homebrew/library">
            App Library
          </NavLink>
          {isAuthenticated && (
            <button
              type="button"
              className="govuk-link homebrew-link-button"
              onClick={() => void signOut()}
            >
              Sign out
            </button>
          )}
        </nav>
      </div>
      <main className="govuk-width-container govuk-main-wrapper" id="homebrew-main">
        <HomebrewAccess>
          <Routes>
            <Route index element={<Library mine />} />
            <Route path="library" element={<Library />} />
            <Route path="add" element={<AddApp />} />
            <Route path="apps/:appId" element={<AppDetail />} />
            <Route
              path="*"
              element={
                <>
                  <h1 className="govuk-heading-l">Page not found</h1>
                  <Link className="govuk-link" to="/homebrew/library">
                    Go to App Library
                  </Link>
                </>
              }
            />
          </Routes>
        </HomebrewAccess>
      </main>
      <footer className="govuk-footer">
        <div className="govuk-width-container">
          <p className="govuk-body-s">
            For developers moving to MacBooks. Package availability does not mean software is
            approved or guaranteed to work on your device.
          </p>
          <p className="govuk-body-s">
            App entries and notes show your email and time posted to Homebrew users. Votes show
            totals only.
          </p>
        </div>
      </footer>
    </div>
  );
}
